module.exports = __webpack_public_path__ + "img/slide_bg_01.f3bfcde0.png";